import { render, staticRenderFns } from "./CreateProjectEvaluation.vue?vue&type=template&id=21e4fce2&scoped=true&"
import script from "./CreateProjectEvaluation.vue?vue&type=script&lang=js&"
export * from "./CreateProjectEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectEvaluation.vue?vue&type=style&index=0&id=21e4fce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e4fce2",
  null
  
)

export default component.exports